

const getStripeKey = () => {
    if (process.env.REACT_APP_STAGE === 'beta' || process.env.NODE_ENV !== 'production' || (window.location.host.startsWith('beta.'))) {
        return 'pk_test_okju7XyNRoXfDWH7eLhOKPws';
    } else {
        return 'pk_live_3lRDz0x8auyzbykJdLYkgKcM';
    }
}

export default getStripeKey;
